
import { combineLatest, Subscription } from 'rxjs';
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { PublicationService } from '../services/publication.service';

@Directive({
	selector: '[hasPublicationField]'
})

export class HasPublicationFieldDirective implements OnInit, OnDestroy {

	@Input() hasPublicationField: string;
	private subscriptions = new Subscription();

	constructor(private el: ElementRef, private publicationService: PublicationService,
		private authenticationService: AuthenticationService) {

		if (this.hasPublicationField) {
			this.showElement(false);
		}
	}

	ngOnInit() {
		if (!this.hasPublicationField) {
			return;
		}

		let extraPublicationFields: string[];
		let conditionalOperator: string;
		let conditionalFields: string[];

		const hasPermissionObservable = this.authenticationService.hasPermission('root');
		const publicationDataObservable = this.publicationService.getData();

		this.subscriptions.add(combineLatest([hasPermissionObservable, publicationDataObservable]).subscribe((res: any[]) => {

			const hasRoot = res[0];
			const publicationData = res[1];
			let publicationFieldEnabled = false;
			let conditionalFieldsEnabled = false;

			if (this.hasPublicationField) {
				if (this.hasPublicationField.toUpperCase().indexOf(' OR ') > -1 && this.hasPublicationField.toUpperCase().indexOf(' AND ') > -1) {
					console.error('hasPublicationField does not currently support both AND and OR operators in a single check');
					return false;
				} else {
					this.hasPublicationField = this.hasPublicationField.replace(/\(/g, '');
					this.hasPublicationField = this.hasPublicationField.replace(/\)/g, '');

					if (this.hasPublicationField.indexOf(' AND ') > -1) {
						conditionalOperator = 'AND';
						conditionalFields = this.hasPublicationField.trim().split(' AND ');
					}
					if (this.hasPublicationField.indexOf(' OR ') > -1) {
						conditionalOperator = 'OR';
						conditionalFields = this.hasPublicationField.trim().split(' OR ');
					}
				}
			}

			if (publicationData) {
				extraPublicationFields = (publicationData.extraPlayoutFields ?
					(
						typeof publicationData.extraPlayoutFields === 'string' ?
							JSON.parse(publicationData.extraPlayoutFields) : publicationData.extraPlayoutFields
					) : []);
				publicationFieldEnabled = extraPublicationFields.indexOf(this.hasPublicationField) !== -1;

				if (conditionalFields) {
					if (conditionalOperator === 'AND') {
						conditionalFieldsEnabled = true;
						for (let i = 0; i < conditionalFields.length; i++) {
							if (extraPublicationFields.indexOf(conditionalFields[i]) === -1) {
								conditionalFieldsEnabled = false;
							}
						}
					} else { // OR
						conditionalFieldsEnabled = false;
						for (let i = 0; i < conditionalFields.length; i++) {
							if (extraPublicationFields.indexOf(conditionalFields[i]) !== -1) {
								conditionalFieldsEnabled = true;
							}
						}
					}
				}
			}

			if (hasRoot || publicationFieldEnabled || conditionalFieldsEnabled) {
				this.showElement(true, publicationFieldEnabled, conditionalFieldsEnabled);
			} else {
				this.showElement(false);
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	private showElement(show: boolean, fieldEnabled?: boolean, conditionalEnabled?: boolean) {
		this.el.nativeElement.style.display = show ? null : 'none';
		if (fieldEnabled || conditionalEnabled) {
			this.el.nativeElement.classList.remove('root');
		} else {
			this.el.nativeElement.classList.add('root');
		}
	}
}
